import { customerApi } from "../../utils/apiConfig";

export const uploadSellerDocument = (userId, file, title, description) => {
  const formData = new FormData();
  formData.append("userId", userId);
  formData.append("title", title);
  formData.append("description", description);
  formData.append("excel", file);

  return customerApi.post("/uploadSatisDocument", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const updateSellerDocument = (updatedId, userId, file, title, description) => {
  const formData = new FormData();
  formData.append("updatedId", updatedId);
  formData.append("userId", userId);
  formData.append("title", title);
  formData.append("description", description);

  if (file) {
    formData.append("excel", file); // dosya seçilmediyse boş göndermiyoruz
  }

  return customerApi.post("/updateSatisDocument", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};


export const getSellerDocuments = () => {
  return customerApi.get("/getSatisDocument", {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};
